
import React from 'react';

const ScannerDivider = () => {
  return (
    <div className="relative flex py-3 items-center">
      <div className="flex-grow border-t border-indigo-200 dark:border-indigo-700/40"></div>
      <span className="flex-shrink mx-3 text-indigo-500 dark:text-indigo-400 font-medium">hoặc</span>
      <div className="flex-grow border-t border-indigo-200 dark:border-indigo-700/40"></div>
    </div>
  );
};

export default ScannerDivider;
